import { useLocation, useResolvedPath } from "react-router";

export function useIsActive(to: string, matchExact: boolean) {
	const location = useLocation();
	const path = useResolvedPath(to);
	const locationPathname = location.pathname;
	const toPathname = path.pathname;
	const isActive =
		locationPathname === toPathname ||
		(!matchExact &&
			locationPathname.startsWith(toPathname) &&
			locationPathname.charAt(toPathname.length) === "/");
	return isActive;
}
